export default __webpack_public_path__ + "static/media/filterIC.4d5b2d3e.svg";